import { useQuery } from '@tanstack/react-query';
import { getGruposByCompeticion } from '../../services/gruposService';

/**
 * Hook para obtener grupos por competición
 * @param {string} idCompeticion - ID de la competición
 * @param {object} options - Opciones de React Query
 */
export const useGrupos = (idCompeticion, options = {}) => {
  return useQuery({
    queryKey: ['grupos', idCompeticion],
    queryFn: () => getGruposByCompeticion(idCompeticion, null),
    enabled: !!idCompeticion,
    staleTime: 30 * 60 * 1000, // 30 minutos
    ...options,
  });
};

export default useGrupos;
